module.exports = __webpack_public_path__ + "assets/img/32@3x.d5af35b0.png";